import { Event } from '@40seas/abstarcts';
import { UserConsentsEvents } from '../user-consents.events.enum';
import { UserConsentsTopics } from '../user-consents.topics.enum';

export const ExtendSessionretentionEvent: Event = {
    eventType: UserConsentsEvents.ExtendSessionRetention,
    snsTopic: UserConsentsTopics.UserConsents,
};
